$(document).on('keyup', '.has-slug', function () {
	$( $(this).data('target') ).val( _.kebabCase( $(this).val() ) );
	$( $(this).data('target') ).trigger('keyup');
});

$(document).on('keyup', '[role="slug"]', function () {
	$( '#' + $(this).attr('id') + '-help' ).text( $(this).val() );
});

$(document).ready(function () {
	$('[role="slug"]').trigger('keyup');
});
